var map = {
	"./appManagement.svg": "6050",
	"./cloudConsultation.svg": "073b",
	"./cloudService.svg": "d9fb",
	"./cloudStorage.svg": "8b4c",
	"./cloudTeaching.svg": "c088",
	"./cloudTeaching1.svg": "b42b",
	"./contactUs.svg": "6091",
	"./dashboard.svg": "f782",
	"./doctor.svg": "bc4d",
	"./example.svg": "30c3",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./home.svg": "6bbe",
	"./link.svg": "18f0",
	"./live.svg": "a8d9",
	"./mai.svg": "e33d",
	"./password.svg": "2a3d",
	"./search.svg": "8e8d",
	"./statisticsManagement.svg": "7a8c",
	"./systemManagement.svg": "3657",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";